<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label>名称</label>
            </div>
            <div class="form-value">
                <span>{{shopComnRepair.title}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>服务类型</label>
            </div>
            <div class="form-value">
                <span>{{shopComnRepair.servcTypeName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>允许抢单</label>
            </div>
            <div class="form-value">
                <span>{{shopComnRepair.grabIssueAllowed ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>创建人</label>
            </div>
            <div class="form-value">
                <span>{{shopComnRepair.creatorName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{shopComnRepair.createTime}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopComnReqApi from '../../api/shopComnReq'

    export default {
        name: 'swb-shop-comn-repair-detail',
        desc: '常规服务请求详情',
        props: ['id'],
        data: function () {
            return {
                //
                shopComnRepair: {}
            }
        },
        created: function () {
            //
            this.toGetShopComnRepairDetail();
        },
        methods: {
            toGetShopComnRepairDetail: function () {
                let self = this;
                let postData = {
                    id: self.id
                };
                //
                let msgBoxDlg = MsgBox.loading();
                shopComnReqApi.getShopComnRepairInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        self.shopComnRepair = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ShopComnRepairDetail.vue